import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'wouter';
import Box from '@mui/material/Box';
import StaticLoader from '../../mui/MuiLoader/StaticLoader/StaticLoader';
import Footer from '../footer/Footer';
import { styles } from './styles';
import { withStyles } from '@mui/styles';

const Page = ({ classes, resolving, header, children = undefined }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Box className={classes.root}>
      {header}
      {resolving && <StaticLoader />}
      {children}
      <Footer />
    </Box>
  );
};

Page.defaultProps = {
  classes: {},
  resolving: false,
  header: null,
};

Page.propTypes = {
  resolving: PropTypes.bool,
  header: PropTypes.node.isRequired,
  children: PropTypes.node,
};

export default withStyles(styles)(Page);
